<template>
  <div>
    <Aguarde :show="showAguarde"></Aguarde>
    <Loader :loading="httpSend">
      <div class="col-12">
        <div class="card-body">
          <div class="row">
            <div class="col-md-5">
              <label for="pes_cpfcnpj">Digite o CPF para pesquisar</label>
              <input v-model="loc_usuario"
                     v-mask="'###.###.###-##'"
                     v-on:focusout="pesquisaUsuario(loc_usuario)"
                     :class="{'is-invalid': usuario_nao_existe}"
                     id="pes_cpfcnpj"
                     type="text"
                     class="form-control"/>
              <div v-show="usuario_nao_existe" class="invalid-feedback">
                {{ usuario_erro }}
              </div>
            </div>
            <div class="col-md-7">
              <label for="pes_nome">Nome Completo</label>
              <input v-model="usuario.pes_nome"
                     id="pes_nome"
                     type="text"
                     :disabled="true"
                     class="form-control"/>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-5">
              <label for="pes_mail">E-mail</label>
              <input v-model="usuario.pes_mail"
                     id="pes_mail"
                     type="text"
                     :disabled="true"
                     class="form-control"/>
            </div>
            <div class="col-md-4">
              <label for="tel_numero">Telefone</label>
              <input v-bind:value="usuario.tel_numero | VMask('(##) # ####-####')"
                     v-mask="'(##) #####-####'"
                     id="tel_numero"
                     type="text"
                     :disabled="true"
                     class="form-control"/>
            </div>
            <div class="col-md-3 mt-4">
              <button type="button" @click="adicionaUsuario()"
                      v-bind:disabled="!usuario.pes_codigo"
                      title="Adicionar Usuário"
                      class="btn btn-success mr-0 mb-0">
                <i class="bx bxs-user-plus"></i> Adicionar Usuário
              </button>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12">
              <div v-show="!list_usuarios.length || list_usuarios.length < 1" role="alert" aria-live="polite"
                   aria-atomic="true" class="alert alert-primary text-center">
                Sem usuários liberados para acessar a empresa
              </div>
              <div v-show="list_usuarios.length && list_usuarios.length > 0" class="table-responsive mb-0">
                <table class="table table-centered">
                  <thead>
                  <tr>
                    <th scope="col">Usuário Liberados*</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="s in list_usuarios" :key="s.pes_cpfcnpj">
                    <td>
                      <h5 class="font-size-14 mb-1">
                        {{ s.pes_nome }}
                      </h5>
                      <p class="text-dark mb-0">{{ s.pes_cpfcnpj | VMask('###.###.###-##') }}</p>
                      <p class="text-muted mb-0">{{ s.pes_mail }}</p>
                    </td>
                    <td>
                      <button type="button" @click="detalhe(s)" title="Detalhe do Usuário"
                              class="btn btn-primary btn-sm mr-0 mb-0">
                        <i class="bx bxs-user-detail"></i> Detalhes
                      </button>
                    </td>
                    <td>
                      <button type="button" @click="confirmaDelete(s)" title="Remover Usuário da Empresa"
                              class="btn btn-danger btn-sm mr-0 mb-0">
                        <i class="bx bxs-user-minus"></i> Remover
                      </button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>

            </div>
          </div>
          <div class="row mt-2">
            <div class="col-12">
              <p>*Usuários administradores não são listados</p>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <b-form-group class="mt-3 text-left">
                <button type="button"
                        @click="voltar"
                        title="Salvar dados da empresa"
                        class="btn btn-dark">
                  <i class="bx bx-arrow-back"></i> Voltar
                </button>
              </b-form-group>
            </div>
          </div>
        </div>
      </div>
    </Loader>
  </div>
</template>
<script>
import Loader from "@/components/widgets/loader";
import Aguarde from "@/components/widgets/aguarde";
import {delUsuarioEmpresa, getDadosUsuarios, saveUsuarioEmpresa} from "@/api/admin/gestao/empresas";
import {getPesquisaUsuario} from "@/api/admin/pessoas/pessoas";
import {soNumeros} from "@/helps/util";
import Swal from "sweetalert2";
const {notifySucesso, notifyErro} = require("../../../../../helps/notificacao");

export default {
  components: {
    Loader,
    Aguarde
  },
  props: {
    eco_codigo: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      showAguarde: false,
      httpSend: false,
      usuario_nao_existe: false,
      usuario_erro: '',
      list_usuarios: [],
      loc_usuario: '',
      usuario: {
        pes_codigo: null,
        pes_nome: '',
        pes_cpfcnpj: '',
        pes_mail: '',
        tel_numero: ''
      }
    };
  },
  created() {
    this.getDados()
  },
  methods: {
    getDados() {
      this.httpSend = true;
      getDadosUsuarios(this.eco_codigo).then(result => {
        this.list_usuarios = result.dados;
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    detalhe(u) {
      this.$router.push({
        name: "admin-pessoas-usuarios-detalhe",
        params: {tipo: 'confirmados', hash: u.aut_hash}
      })
    },
    pesquisaUsuario(pes_cpfcnpj) {
      if (!pes_cpfcnpj) {
        return
      }
      if (pes_cpfcnpj.length < 11) {
        return
      }
      this.httpSend = true;
      getPesquisaUsuario(soNumeros(pes_cpfcnpj)).then(response => {
        this.usuario_nao_existe = false;
        if (response.status) {
          this.usuario = response.dados;
        } else {
          this.usuario_erro = response.mensagem;
          this.usuario_nao_existe = true;
          this.usuario = {
            pes_codigo: null,
            pes_nome: '',
            pes_cpfcnpj: '',
            pes_mail: '',
            tel_numero: ''
          }
        }
      }).catch(error => {
        console.log(error);
      }).finally(() => {
        this.httpSend = false;
      })
    },
    adicionaUsuario() {
      this.httpSend = true;
      saveUsuarioEmpresa(this.eco_codigo, this.usuario).then(result => {
        if (result.status) {
          notifySucesso("DattaNFSe", result.mensagem)
          this.getDados();
        } else {
          notifyErro("DattaNFSe", result.mensagem)
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    confirmaDelete(u) {
      Swal.fire({
        title: "Remover Usuário",
        html: `Deseja realmente remover o usuário <b>${u.pes_nome}</b> ?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f14646",
        cancelButtonColor: "#100e0e",
        confirmButtonText: "Sim",
        cancelButtonText: "Não"
      }).then(result => {
        if (result.isConfirmed) {
          this.removeUsuario(u);
        }
      });
    },
    removeUsuario(u) {
      this.httpSend = true;
      delUsuarioEmpresa(this.eco_codigo, u.aut_hash).then(result => {
        if (result.status) {
          notifySucesso("DattaNFSe", result.mensagem)
          this.getDados();
        } else {
          notifyErro("DattaNFSe", result.mensagem)
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    voltar() {
      this.$router.back();
    },
  }
};
</script>

